<template>
    <div>
        <!-- Modal confirm delete account -->
        <modal :name="'modal-add-photo-' + _uid">
            <div class="text-2xl font-bold text-center">{{ $tt('Prendre une photo depuis votre smartphone') }}</div>

            <div class="mt-4">
                <template v-if="!pusherFile">
                    <div class="mb-4 text-center text-lg bg-slate-100 rounded-lg p-4">
                        <i class="fas fa-camera mr-1"></i> {{ $tt('Flasher le qrcode avec votre smartphone') }}
                        <div class="text-sm border-t pt-4 mt-4 border-slate-400">
                            {{ $tt("Ou accéder à l'url suivante avec votre smartphone :")}}
                            <div class="underline">{{ qrCodeUrl }}</div></div>
                    </div>
                    <div class="flex justify-center">
                        <qr-code :text="qrCodeUrl" />
                    </div>
                </template>
                <template v-if="pusherFile">
                    <div>
                        <img :src="pusherFile.url" class="w-[250px] mx-auto rounded">
                    </div>
                    <div class="flex gap-2 mt-4 justify-center">
                        <button class="px-4 py-2 bg-green-500 hover:bg-green-600 duration-200 text-white rounded-lg" @click="validatePusherFile">Valider</button>
                        <button class="px-4 py-2 bg-red-500 hover:bg-red-600 duration-200 text-white rounded-lg" @click="removePusherFile">Supprimer</button>
                    </div>
                </template>
            </div>
        </modal>
        
        <div class="flex gap-2" v-if="takePhoto">
            <sav-spinner class="my-3" v-if="loadingUpload" :size="10" />
            <a v-if="fileUrl" :href="fileUrl" target="_blank" class="px-4 py-2 rounded-lg bg-blue-400 hover:bg-blue-500 text-white duration-200 text-sm mb-2">
                <i class="mr-1 fas fa-link"></i>{{$t('composants.sav-input-file-upload.consulter_le_fichier')}}
            </a>
            <button @click="openInput" class="px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 duration-200 text-sm mb-2">
                <i class="fas fa-upload mr-1"></i> Ajouter un fichier
            </button>
            <button @click="openSocketPicture" class="hidden md:block px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 duration-200 text-sm mb-2">
                <i class="fas fa-camera mr-1"></i> Prendre une photo
            </button>
        </div>
        <input
        type="file"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
        :class="takePhoto ? 'fixed -mt-[4000px] -ml-[4000px]' : ''"
        :id="labelToId"
        :placeholder="placeholder"
        :accept="camera ? 'image/*' : 'image/*,application/pdf'"
        @change="upload"
        :disabled="disabled"
        :camera="camera ? 'environment' : null"
        >

        <div v-if="!takePhoto">
            <sav-spinner class="my-3" v-if="loadingUpload" :size="10" />
            <div class="my-1" v-if="fileUrl && !loadingUpload">
                <a :href="fileUrl" target="_blank" class="text-sm text-blue-500 hover:underline">
                    <i class="mr-1 fas fa-link"></i>{{$t('composants.sav-input-file-upload.consulter_le_fichier')}}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import apiUploadService from '@/services/apiUpload.service'
import Compressor from 'compressorjs';

export default {
    props: {
        label: {
            type: String,
        },
        classSrc: {
            type: String
        },
        placeholder: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        defaultData: {},
        takePhoto: {default: 1},
        camera: {default: 0},
        id: {},
    },
    data() {
        return {
            loadingUpload: false,
            fileUrl: null,
            fileData: null,
            randomToken: null,
            pusher: null,
            pusherChannel: null,
            pusherFile: null
        }
    },
    computed: {
        labelToId: function() {
            if (this.label) {
                return this.label.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"").replace(/\s/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
        },

        qrCodeUrl() {
            return window.location.href.split('/form')[0] + '/p/' + this.randomToken
        }
    },
    methods: {
        async uploadFile(fileInput) {
            if (fileInput) {
                this.fileUrl = null
                let response = await apiUploadService.post({
                    files: fileInput
                })
                this.fileData = response.data.files[0]
                if (this.fileData) {
                    this.fileUrl = this.fileData.url
                    // Emit Parent
                    this.$emit('input', this.fileData)
                }
            } else {
                this.fileUrl = null
            }
        },

        compressFile(file) {
            if (!file) {
                return;
            }

            new Compressor(file, {
                quality: 0.5,
                convertSize: 0,
                convertTypes: ['image/gif', 'image/jpeg', 'image/png', 'image/heic', 'image/webp'],

                success: async (result) => {
                    if (result.size < 5000000) {
                        await this.uploadFile(result)
                    } else {
                        this.$toast.error(this.$t('composants.sav-input-file-upload.fichier_trop_volumineux'))
                    }
                    this.loadingUpload = false
                },
                error(err) {
                    console.warn('Error image compression:');
                    console.log(err.message);
                    return file
                },
            });
        },

        async upload(event) {
            // Loader
            this.loadingUpload = true

            // Set data
            let fileInput = event.target.files.length > 0 ? event.target.files[0] : null

            // Compress image
            if (fileInput) {
                let isFileImage = (file) => {
                    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/heic', 'image/webp'];
                    return file && acceptedImageTypes.includes(file['type'])
                }
                if (isFileImage(fileInput)) {
                    this.compressFile(fileInput)
                    return
                }
            }

            // Api
            await this.uploadFile(fileInput)

            // Loader
            this.loadingUpload = false
        },

        openSocketPicture() {
            this.$modal.show('modal-add-photo-' + this._uid)

            if (!this.pusher) {
                this.pusher = new Pusher('badf456ece97be1ac910', {
                    cluster: 'eu'
                });
    
                this.pusherChannel = this.pusher.subscribe('take-picture');
            }
            this.pusherChannel.bind(this.randomToken, (data) => {
                data = JSON.parse(data)
                this.pusherFile = data
            });
        },

        validatePusherFile() {
            this.fileData = this.pusherFile
            this.fileUrl = this.pusherFile.url
            this.pusherFile = null
            this.$modal.hide('modal-add-photo-' + this._uid)
            this.$emit('input', this.fileData)
        },

        removePusherFile() {
            this.pusherFile = null
        },

        openInput() {
            let el = document.getElementById(this.labelToId)
            if (el) {
                el.click()
            }
        },
    },
    mounted() {
        if (this.defaultData) {
            this.defaultData
            this.fileData = this.defaultData
            this.fileUrl = this.defaultData.url
        }

        var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var token = '';
        for (var i = 0; i < 10; i++) {
            token += chars[Math.floor(Math.random() * chars.length)];
        }
        this.randomToken = token
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavInputFileUpload.vue